module.exports = __webpack_public_path__ + "img/Russia.bfe6f697.jpg";